module.exports = __webpack_public_path__ + "img/header-alert-bell_yellow.svg";